'use client'

/**
 * Is a route error boundary on screen? (#13956.)
 *
 * The read half of `src/lib/errors/route-error-posture.ts`, which carries the
 * argument for why the answer travels through a module store at all. Kept in
 * `src/hooks/` rather than in the store module so the store stays a plain,
 * React-free, client-safe module the way `meeting-page-context.ts` is — the
 * publisher (`RouteErrorBoundary`) needs the store, not this hook.
 *
 * `useSyncExternalStore` rather than a `useState` + `useEffect` pair: the
 * consumers are root-layout chrome that must not paint one frame of a FAB
 * over an error card, and the third argument is what keeps the server render
 * honest (it is always `false`).
 */

import { useSyncExternalStore } from 'react'

import {
  getRouteErrorActive,
  getServerRouteErrorActive,
  subscribeToRouteErrorPosture,
} from '@/lib/errors/route-error-posture'

export function useRouteErrorActive(): boolean {
  return useSyncExternalStore(
    subscribeToRouteErrorPosture,
    getRouteErrorActive,
    getServerRouteErrorActive,
  )
}
